import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import classnames from 'classnames'
import headshotImg from '../../assets/images/bio-headshot.png'

const Hero = ({
  className
}) => {
  const [timeOfDay, setTimeOfDay] = useState('');

  useEffect(() => {
    const today = new Date();
    const hour = today.getHours();

    let time;
    if (hour < 12) {
      time = 'morning';
    } else if (hour < 17) {
      time = 'afternoon';
    } else {
      time = 'evening';
    }

    setTimeOfDay(time);
  }, []);

  function yearsExp(year) {
    const currentYear = new Date().getFullYear();
    return currentYear - year;
  }

  let experience = yearsExp(2009)

  return (
    <section className={classnames('hero', className)}>
      <header className="hero__header">
        <img className="hero__headshot" src={headshotImg} alt="me"/>
        <h1>G’{timeOfDay}, <NavLink to="bio">I&apos;m Drew</NavLink></h1>
        <h3>
          Senior Designer @Publix - AI & Process Enthusiast - Student Mentor @CareerFoundry -
          Impacted 100M+ users at Publix, Walmart, It Works!, and Tropicana.
        </h3>
      </header>
      <p>I've spent the last {experience} years designing digital experiences across ecommerce, SaaS, and internal enterprise tools — from early startups to Fortune 100 corps. My roots are in UX, but I've led teams, owned high risk problems, built systems, and shaped strategy along the way.</p>
      <p>Today, I'm leading AI and design for business at Publix, where I work across product, design, and engineering to bring strategic improvements into our tools and workflows.</p>
    </section>
  );
};

export default Hero;
